import { apiFetch } from "./http";
import type { Filial, FilialPaginatedList } from "@/types/api";

export interface ListarFiliaisParams {
  pesquisa?: string;
  codigo?: string;
  ativo?: boolean;
  favoritado?: boolean;
  offset?: number;
  limit?: number;
  [k: string]: unknown;
}

export interface FilialInput {
  nome_fantasia: string;
  razao_social?: string | null;
  codigo?: string | null;
  cnpj?: string | null;
  email?: string | null;
  telefone?: string | null;
  ativo?: boolean | null;
  fixar_nome?: boolean | null;
  favoritado?: boolean | null;
}

export const filiaisApi = {
  listar: (params: ListarFiliaisParams = {}) =>
    apiFetch<FilialPaginatedList>("/api/filiais", { query: params }),
  obter: (id: string) => apiFetch<Filial>(`/api/filiais/${id}`),
  criar: (input: FilialInput) =>
    apiFetch<Filial>("/api/filiais", { method: "POST", body: input }),
  atualizar: (id: string, input: FilialInput) =>
    apiFetch<Filial>(`/api/filiais/${id}`, { method: "PUT", body: input }),
  remover: (id: string) =>
    apiFetch<void>(`/api/filiais/${id}`, { method: "DELETE" }),
};
